import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import availableLanguages from './components/common/availableLanguages.json';
import {
  DEFAULT_LANGUAGE,
  getQueryLanguage,
  LANGUAGE_DETECTION_ORDER,
  LANGUAGE_LOCAL_STORAGE_KEY,
  LANGUAGE_QUERY_DETECTOR,
  LANGUAGE_QUERY_PARAMETER,
  normalizeDetectedLanguage,
} from '@/utilities/language';

const languageDetector = new LanguageDetector();

languageDetector.addDetector({
  name: LANGUAGE_QUERY_DETECTOR,
  lookup: () => {
    if (typeof window === 'undefined') return undefined;

    let search = window.location.search;
    if (!search && window.location.hash.includes('?')) {
      search = window.location.hash.substring(window.location.hash.indexOf('?'));
    }

    return getQueryLanguage(search) ?? undefined;
  },
});

i18n
  .use(languageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    supportedLngs: availableLanguages.map((language) => language.code),
    fallbackLng: DEFAULT_LANGUAGE,
    detection: {
      order: [...LANGUAGE_DETECTION_ORDER],
      lookupQuerystring: LANGUAGE_QUERY_PARAMETER,
      lookupLocalStorage: LANGUAGE_LOCAL_STORAGE_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeDetectedLanguage,
    },
    load: 'languageOnly',
    backend: {
      loadPath: (BASE || '/') + 'i18n/{{lng}}.json',
      requestOptions: { cache: 'no-cache' },
    },
    interpolation: {
      escapeValue: true,
    },
  })
  .catch(() => {
    console.error('Could not initialize i18n');
    // now what ?
  });

export default i18n;
